



import { Box, Button, CircularProgress } from '@mui/material'
import styles from './style'
import SearchTextField from '../../components/searchTextField/SearchTextField'
import DataTable from '../../components/DataTable/DataTable'
import { useState, useEffect } from 'react'
import {useNavigate} from 'react-router-dom'


export default function Dependents({ onMount, loading, data, changeTab, filter, submitSearch, clearSearch }) {

    let filterSearch = ""
    const [page, setPage] = useState(0);
    const [sortedTable, setsortedTable] = useState(data);
    const role = sessionStorage.getItem("userRole")
    const navigate=useNavigate()


    const onChangePagination = (newPage) => {
        onMount({ page: newPage, filter: filter })
        setPage(newPage)
    }
    useEffect(() => {
        setsortedTable(data)
    }, [data])

    useEffect(() => {
        onMount({ page: 0, filter: filter })
        changeTab(3)
    }, [])

    useEffect(() => {
        onMount({ page: 0, filter: filter });
    }, [filter,onMount])

    const showData = (data) => {

        let showtable = [];
        if (data.length > 0) {
            data.map((item, index) => {

                showtable.push({ ...item });
                showtable[index] = {
                    ...showtable[index],
                    nameLabel: item.firstName + " " + item.lastName
                }
            })
        }
        return showtable;
    }

    let headers = [
        {
            name: "שם מלא",
            width: "15%",
            table: "nameLabel"
        },
        {
            name: "כתובת מייל",
            width: "10%",
            table: "email"
        },
        {
            name: "טלפון",
            width: "10%",
            table: "phone"
        },
        {
            name: "עיר",
            width: "10%",
            table: "city"
        },
    ]


    return (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box sx={styles.wrap}>
                <Box sx={styles.actions}>
                    {(role === "admin" || role === "officer") && <Button
                        variant="contained"
                        disableRipple
                        onClick={() => { navigate("/") }}
                        sx={styles.createButton}>
                        צור נתמך
                    </Button>}
                    <SearchTextField
                        onEmptySearch={() => { clearSearch() }}
                        onSearch={() => { submitSearch(filterSearch) }}
                        width="30%"
                        setSearch={(item) => { filterSearch = item }}
                        placeholder="חיפוש נתמך"
                    />
                </Box>
                <Box>
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {loading ?
                            <CircularProgress color="primary" sx={{ position: "absolute", top: "50%", left: "50%" }} /> :
                            <DataTable
                                fdata={sortedTable}
                                showData={showData}
                                headers={headers}
                                onChange={onChangePagination}
                                page={page}
                            />
                        }
                    </Box>
                </Box>

            </Box>
        </Box>
    )
}